module.exports = __webpack_public_path__ + "img/men1-img.4c4df79a.png";